export default __webpack_public_path__ + "static/media/ic-data-operator.e6298dc8.svg";